import React, { FC, useState } from "react";
import cn from "clsx";
import { Link } from "react-router-dom";
import { getRedirectionUrl, isLinkStartsFromHTTPS } from "../../../util/common";
import { isMobile } from "../../../util";
import BannerIntersectionObserver from "../../banner/bannerIntersectionObserver";
import { useRouteSlug } from "@/hooks";
import { BannerImage } from "@/routes/catalogPage/types";
import Img from "@/components/img";

const stylesForSingleRow = (
  { hover, ...restStyles },
  { hovered, imageWidth, marginForImage, hoverValues }
) => ({
  ...restStyles,
  ...(!isMobile.any() && hovered && hoverValues && hover),
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flex: `1 0 calc(${imageWidth}% - ${marginForImage}px)`
});

const CarouselItem: FC<{
  imageContent: BannerImage;
  language: string;
  imageWidth: number;
  dataForAnalytic: any;
  itemIndex: number;
}> = ({ imageContent, language, imageWidth, dataForAnalytic, itemIndex }) => {
  const [hovered, setHovered] = useState(false);
  const routeSlug = useRouteSlug();
  const styles = imageContent.styles;
  const content = imageContent[language];
  const redirectionLink = content?.redirectionLink;
  const hoverValues = styles.hoverValues?.transform;
  const marginForImage = styles.marginLeft + styles.marginRight || 0;
  const isExternalLink =
    redirectionLink && isLinkStartsFromHTTPS(redirectionLink);
  const redirectionPath = isExternalLink
    ? redirectionLink
    : `/${routeSlug}${redirectionLink || "/"}`;
  const linkTarget = isExternalLink ? "_blank" : "_self";
  const imageSrc = imageContent[language]?.imageURL;

  return (
    <Link
      className={cn("carousel-link", {
        "disabled-link": !redirectionLink
      })}
      to={getRedirectionUrl(isExternalLink, redirectionPath)}
      target={linkTarget}
      style={stylesForSingleRow(styles, {
        imageWidth,
        marginForImage,
        hovered,
        hoverValues
      })}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      data-banner-link={redirectionLink}
      data-banner-index={itemIndex}
    >
      <BannerIntersectionObserver data={dataForAnalytic}>
        <div
          className="banner-element"
          style={{ paddingBottom: `${content?.ratio}%` }}
        >
          <div className="image-wrapper">
            <Img
              src={imageSrc}
              alt="banner-image"
              className="banner-image"
              imagePlaceholderType="GENERIC_CAROUSEL"
            />
          </div>
        </div>
      </BannerIntersectionObserver>
    </Link>
  );
};

export default CarouselItem;
